import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import Footer from "../components/footer"

export const query = graphql`
query Capability2Query($id: String!) {
  butterPage(id: {eq: $id}) {
    id
    content
    slug
  }
}`

const Legal = (props) => {
  const { data, errors } = props
  const content = data.butterPage.content
  const id = data.butterPage.id

  return (
    <React.Fragment>
      <Layout>
       <div className="legal capability">
         <div className="content">
            <div className="inside">
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <div
                 dangerouslySetInnerHTML={{__html: content}}
               />
            </div>
          </div>
        </div>
      </Layout>
      <Footer />
    </React.Fragment>
  )
}

export default Legal
